import { API } from "../../../api/api";
import { SubsidiariesAPIRoutes } from "./apiRoutes";

const getSubsidiaries = () => {
    const odataParameters = {
        skip: 0,
        top: 10000
    };
    return API.request({
        routeID: SubsidiariesAPIRoutes.GET_SUBSIDIARIES,
        odataParameters
    });
};

const editLogo = (subsidiaryId, logo) => {
    return API.request({
        routeID: SubsidiariesAPIRoutes.EDIT_SUBSIDIARY,
        parameters: { logo },
        routeParameters: { subsidiary_id: subsidiaryId },
        formData: false
    });
};

export const subsidiariesAPI = {
    getSubsidiaries,
    editLogo
};
